// Libraries
var React = require('react');

// Styles
require('./MembershipList.scss');

// Components
var MembershipGroup = require('./MembershipGroup');

class MembershipListModule extends React.Component {

	render() {


		return (
			<div className="MembershipList" id={this.props.data.id || null}>
				{this.props.data.title && this.props.data.title.length > 0 &&
					<h2>{this.props.data.title}</h2>
				}
				{this.props.data.memberships && this.props.data.memberships.map(function (memberships, index) {
						return (<MembershipGroup memberships={memberships} key={index} />);
					})
				}
			</div>
		)
	}
}

module.exports = MembershipListModule;



// WEBPACK FOOTER //
// ./src/components/Membership/MembershipListModule.js